import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import * as Sentry from "@sentry/vue";

import "./cvr"


import './style.css'
import App from './App.vue'

import { router } from './router.js'

let minRoot = import.meta.env.VITE_MIN_ROOT;

// let resp = await fetch(minRoot + '/sanctum/csrf-cookie')

import { registerSW } from 'virtual:pwa-register'
const updateSW = registerSW({
    onNeedRefresh() {
        // TODO: display user-facing prompt with "refresh" (call `updateSW()`) & 
        // "cancel" (close prompt) buttons
        if(window.confirm("Update available: do you wish to install it?")) {
            updateSW();
        }
    },
    onOfflineReady() {
        // TODO: display user-facing "ready to work offline" message 
        // with an "ok" (close prompt) button
        window.alert('offline ready');
    },
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)
app.use(pinia)
app.provide('minRoot', minRoot)

if (import.meta.env.VITE_SENTRY_ENABLE == 1) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        environment: import.meta.env.VITE_SENTRY_ENV,
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        //tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

app.use(router)
app.mount('#app')
